import { Component, OnInit } from '@angular/core';
import { AppState } from '../store';
import { Store } from '@ngrx/store';
import { Subscriber } from '../shared/lib/helpers/subscriber';
import { env } from '../../../env';
import { LanguageService } from 'app/shared/services/utils/language.service';

@Component({
    selector: 'app-access',
    templateUrl: './access.component.html',
})
export class AccessComponent extends Subscriber implements OnInit {
    url = '';
    bannerPromo = '';
    background = '';
    logo = '';
    userLang: string;

    constructor(private store: Store<AppState>, private languageService: LanguageService) {
        super();
    }

    ngOnInit() {
        this.subscribeRouter();
        this.checkSubdomain();
    }

    /**
     * Router to determine component
     */
    subscribeRouter() {
        this.addSubscription(
            this.store
                .select((state) => state.router.state)
                .subscribe((state) => {
                    this.url = state.url;
                })
        );
    }

    /**
     * Check subdomain to set background
     */
    checkSubdomain() {
        // Extract subdomain and language
        const hostname = window.location.hostname;
        let subdomain = hostname.split('.').shift();
        const language = navigator.language.replace(/\-.*/, '');

        switch (subdomain) {
            case 'www':
            case 'gruposoledad':
            case 'localhost':
            case 'gruposoledad-b2b2018-front':
                subdomain = 'gruposoledad';
                break;
        }

        this.background = env.urlBackgroundLoginPrefix + subdomain + '-background_' + language + '.jpg';
        this.bannerPromo = env.urlBackgroundLoginPrefix + subdomain + '-banner_' + language + '.jpg';
        this.logo = env.urlBackgroundLoginPrefix + subdomain + '-logo.svg';
    }
}
